import { ReactNode } from "react";
import { useAuth } from "@/lib/auth-context";
import LoginPage from "./LoginPage";

/** Gate for all /admin routes: shows the login screen until authenticated. */
export function AdminShell({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return <>{children}</>;
}
